export default __webpack_public_path__ + "static/media/futurearchitecture.31e89681.jpeg";